import { Component, Input, OnChanges, OnInit } from '@angular/core';

import * as d3 from 'd3';

import { AccessorType } from '../../models/accessor.type';
import { Serie } from '../../models/serie.type';
import { LineConfig } from '../../models/config/line.config';
import { Dimensions } from '../../models/dimensions.type';

@Component({
    selector: '[aaLine]',
    templateUrl: './line.component.html',
    styleUrls: [
        './line.component.scss'
    ],
    standalone: false
})
export class LineComponent implements OnInit, OnChanges
{
    @Input() dimensions: Dimensions;
    @Input() serie: Serie;
    @Input() y0Accessor?: AccessorType;
    @Input() interpolation?: d3.CurveFactory | d3.CurveFactoryLineOnly = d3.curveMonotoneX;
    public lineString: string = '';
    private defaultConfig = {
        color: '#000000',
        width: 2
    } as LineConfig;
    private config: LineConfig = new LineConfig;

    ngOnInit (): void
    {
        Object.assign(this.config, this.defaultConfig);
        if (this.serie.config !== null)
        {
            Object.assign(this.config, this.serie.config);
        }

        this.lineGenerator();
    }

    ngOnChanges (): void
    {
        this.lineGenerator();
    }

    private lineGenerator ()
    {
        const lineGenerator = d3.line()
            .defined((d: any) =>
                d.dp[0] !== null
            )
            .x(this.serie.xAccessorScaled)
            .y(this.serie.yAccessorScaled)
            .curve(this.interpolation);

        this.lineString = lineGenerator(this.serie.dataPoints);
    }
}
